import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICalendar } from 'datebook';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { BrandViewModel } from '../../business-entities/brand.interface';
import { SettingService } from '../../business-services/setting.service';
import { AppState } from './../../business-entities/app-state.interface';
import { SummaryService } from './../../business-services/summary.service';
import * as Enums from './../../utils/enums';
import { WidgetCustomerVehicleDetails } from '../../business-entities/widget-customer-vehicle-details-model';
import { CallDealerLogEntryRequestModel } from './../../business-entities/call-dealer-log-entry-requestModel';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import * as FileSaver from 'file-saver';


@Component({
    selector: 'app-summary',
    templateUrl: 'summary.component.html'
})
export class SummaryComponent implements OnInit {
    appData: AppState;
    selectedDate: string;
    brandList: BrandViewModel[];
    additionalServices:any[]=[];
    pickUpDateTime:any;
    stonchip:string;
    isnewCustomerVehicle:boolean;
    selectedCustomerVehicleDetails:WidgetCustomerVehicleDetails;
    trackerLinkURLMessage:boolean;
    customerName:string;
    customerEmail:string;
    constructor(
        private readonly commonService: CommonService,
        private readonly router: Router,
        private readonly summaryService: SummaryService,
        public settingService: SettingService,
        public datepipe: DatePipe,
    ) { }

    ngOnInit(): void {
        this.selectedCustomerVehicleDetails = this.commonService.getSelectedCustomerVehicleDetails();
        this.customerEmail = (this.selectedCustomerVehicleDetails?.cusT_EMAILID!=null&&this.selectedCustomerVehicleDetails?.cusT_EMAILID!=undefined)?this.selectedCustomerVehicleDetails?.cusT_EMAILID:this.selectedCustomerVehicleDetails?.CUST_EMAILID;
        this.customerName = (this.selectedCustomerVehicleDetails?.cusT_NAME!=null&&this.selectedCustomerVehicleDetails?.cusT_NAME!=undefined)?this.selectedCustomerVehicleDetails?.cusT_NAME:this.selectedCustomerVehicleDetails?.CUST_NAME;
        if (!this.commonService.GetAppointmentStatus) {
            this.router.navigate([Enums.AppRoutes.Booking]);
        } else {
            this.appData = this.commonService.getAppData();
            this.stonchip = this.appData.otherIssuesInput;
        }
        this.getAdditionService();
        this.getpickupDateTime();
        this.getBrands();
        this.checkTimeDifference();
        this.isnewCustomerVehicle = this.selectedCustomerVehicleDetails?.isOriginalVehicle != 1;
    }

    getpickupDateTime()
    {
        if(this.appData?.isPickupDropOffServiceSelection)
        {
            this.pickUpDateTime=this.appData.pickupDatetime;
        }
    }

    CallDealerLogEntry(){
        let data =this.appData;
         let request:CallDealerLogEntryRequestModel ={
             licensePlate:'',
             customerId:'',
             dealerPhone:data?.selectedDealer?.contact.toString(),
             dealerId:data?.selectedDealer?.dealerId,
             workOrderNumber:'',
             applicationId:Application.Widget,
             appointmentGUID:data?.appointmentGuid
           }
          this.summaryService.callDealerLogEntry(request).then((res) => {
          })
      }

    getAdditionService()
    {
        if (this.appData?.selectedAdditionService) {
            Object.keys(this.appData.selectedAdditionService).forEach(key => {
              const val = this.appData.selectedAdditionService[key];
               const additionalService = this.commonService.dealerRecommendedService.find(x => x.serviceId === +key);
               if (val) {
                const temp = {
                  Id: +key,
                  name: additionalService.name,
                  price:additionalService.price,
                  priceIncVat:additionalService.priceIncVat
                };
                this.additionalServices.push(temp);
              }
            });
          }
        }

    getBrands()
    {
        this.brandList = this.summaryService.brandList;
    }
   getBrandLogo(brandCode)
   {
       if(this.brandList && this.brandList.length > 0)
       {
            return this.brandList.filter(x=>x.brandCode.toUpperCase() === brandCode.toUpperCase())[0].image
       }
   }

    onAddtoMyCalender() {
        const selectedDealer = this.appData.selectedDealer;
        const icalendar = new ICalendar({
            title: `${this.selectedCustomerVehicleDetails.licensePlateNo}-Appointment`,
            location: `${selectedDealer.dealerName}, ${selectedDealer.address ? selectedDealer.address + ', ' : null}${selectedDealer.city ? selectedDealer.city + ', ' : null}${selectedDealer.pincode ? '- ' + selectedDealer.pincode : null}`,
            description: `Appointment booked for Licence Plate: ${this.selectedCustomerVehicleDetails.licensePlateNo} with Dealer: ${selectedDealer.dealerName}`,
            start: new Date(this.appData.planningStartTime + 'Z'),
            end: new Date(this.appData.planningEndTime + 'Z'),
        });
        const ics = icalendar.render()
        const blob = new Blob([ics], {
        type: 'text/calendar'
        })
        FileSaver.saveAs(blob, 'Appointment.ics')
    }

    onClose(): void {
        location.reload();
    }

    checkTimeDifference() {
        const startTimeString: string = this.appData.selectedSlot.startTimeLocal;
        const startTime: Date = new Date(startTimeString);
        const currentTime: Date = new Date();
        const differenceInMilliseconds: number = startTime.getTime() - currentTime.getTime();
        const differenceInHours: number = differenceInMilliseconds / (1000 * 3600);

        if (differenceInHours > 24) {
            this.trackerLinkURLMessage = true;
        }
    }
}
